import { render, staticRenderFns } from "./StepLayout.vue?vue&type=template&id=9920cf7a&scoped=true"
import script from "./StepLayout.vue?vue&type=script&lang=js"
export * from "./StepLayout.vue?vue&type=script&lang=js"
import style0 from "./StepLayout.vue?vue&type=style&index=0&id=9920cf7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9920cf7a",
  null
  
)

export default component.exports